<template>
  <div v-if="bodyShow" class="buying-tickets-detais">
    <!-- header -->
    <div class="header">
        <img class="banner" :src="item.banner?item.banner:'https://misc.xjy.cn/zuoziji/banner.jpg'" alt="">
        <div class="text">
            <img  class="city-img" src="@a/be-myself/2020/city-min.png" alt="">
            <span class="city-text">{{item.province+' '+item.city+' '+item.district}}  会场</span>
<!--            <img class="time-img" src="@a/be-myself/2020/time.png" alt="">-->
<!--            <span class="t">12月30日·{{JSON.parse(item.detail)?JSON.parse(item.detail).createTime:''}}</span>-->
            <!-- <span>不见不散</span> -->
        </div>
    </div>
    <!-- text -->
    <div class="box">
        <div class="h3">{{item.name}}  <span style="color: red;">￥{{item.price/100}}</span></div>
        <div class="people-num">
            <div class="userimg">
                <img v-for="(u,idx) in userImg" :key="idx" :src="u.headimgurl" alt="">
            </div>
            <div class="text">
<!--                <span>{{pages.count}}</span>人已购票，还剩<span>{{item.stock-pages.count}}</span>张票-->
                <span>{{item.paid}}</span>人已购票，还剩<span>{{item.stock-item.sold}}</span>张票
            </div>
        </div>
    </div>
    <img class="content" :src="item.content" />
    <!-- 点击购票 -->
    <a class="payBtn" @click="toPayPiao()">点击购票</a>
  </div>
</template>

<script>
import { productGet,orderBuyList,evenAdd } from "@/api/be_myself"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            item:{},
            pages:{},
            userImg:[]
        }
    },
    methods:{
        // 跳转下单页面
        toPayPiao(){
            this.$router.push({
                path:'/buying_tickets_information',
                query:{
                    product_id:this.$route.query.id
                }
            });
        },
        // 获取商品信息
        pullData(){
            if(!this.$route.query.id){
                this.$toast('商品id不能为空！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"超级个体，更值钱更热爱更自在(σ≧∀≦σ)");
            productGet({
                id:this.$route.query.id
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.item = data.item;

                this.bodyShow =true;

            });
            let obj = {
                page:1,  //页码，默认1
                size:4,   //每页数量，默认10
                product_id:this.$route.query.id
            };
            orderBuyList(obj).then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.pages = data.pager;
                this.userImg = data.list;
            });
            // 统计访问商品人熟
            evenAdd({
                event:'PageAccess',
                product_id:this.$route.query.id
            }).then((data)=>{

            })
            shareCon("beMyself", this);
            
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped >
    .buying-tickets-detais{
        padding-bottom: 100px;
        .header{
            position: relative;
            width: 100%;
            max-width: 750px;
            height: 342px;
            overflow: hidden;
            .banner{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .text{
                position: absolute;
                width: 100%;
                bottom: 0;
                left: 0;
                display: flex;
                align-items: center;
                font-size: 28px;
                color: #FFFFFF;
                padding: 20px 24px;
                background: rgba($color: #000000, $alpha: 0.7);
                .city-img{
                    width: 30px;
                    margin-right: 16px;
                }
                .time-img{
                    margin-left: 24px;
                    width: 27px;
                    height: 27px;
                    margin-right: 18px;
                }
                .t{
                    margin-right: 24px;
                }
            }
        }
        .box{
            padding: 24px;
            background-color: #FFFFFF;
            .h3{
                font-size:32px ;
                font-weight: bold;
                line-height: 44px;
                color: #000000;
                margin-bottom: 20px;
            }
            .people-num{
                display: flex;
                align-items: center;
                .userimg{
                    display: flex;
                    align-items: center;
                    img{
                        width: 64px;
                        height: 64px;
                        border-radius: 50%;
                        margin-left: -24px;
                        &:first-child{
                            margin-left: 0;
                        }
                    }
                }
                .text{
                    font-size:28px;
                    color:#606060 ;
                    span{
                        color: #0890CE;
                        margin: 0px 16px;
                        font-weight: bold;
                    }
                }
            }
        }
        .content{
            width: 100%;
        }
        .payBtn{
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            max-width: 750px;
            line-height: 100px;
            //background: #0890CE;
            background: #ff504c;
            font-size:32px ;
            color: #FFFFFF;
            text-align: center;
        }
    }
</style>